import { put, call, select, delay } from 'redux-saga/effects';
import {
  FETCH_CONVERSATIONS,
  TOGGLE_PINNED,
  MARK_READ,
  NAV_TO_CONVERSATION,
  NAV_TO_ORDER_CONV,
  REMOVE_CONVERSATION,
  QUERY_CONV_STATS,
} from './actionTypes';
import { RECEIVE_MESSAGE } from '../messages/actionTypes';
import { RTM_CONV_CREADTED } from '../socket/actionTypes';
import { fetchConvs } from '../conversations/actions';
import { getCurrentUser } from '../user/selectors';
import * as services from './services';
import {
  convsFetched,
  convUpdated,
  pinnedChange,
  hoistConv,
  markReadSuccess,
  addConversation,
  navToConversation,
  queryConvStats,
  convStatsFetched
} from './actions';
import { addOrder } from '../orders/actions';
import { fetchGroupManager } from '../managers/actions';
import { fetchStaffConvs } from '../tenants/actions';
import {
  getConvByIdSelector,
  getConvByOrderIdSelector,
  currentConvIdSelector,
  firstConvSelector,
  getConvQueryTypeSelector
} from './selectors';
import { message } from 'antd';

const isTenantMode = process.env.APP_MODE === 'tenant';
let playRingLock = false;

export default {
  *[NAV_TO_CONVERSATION]({ payload }) {
    const { id, orderId } = payload;
    localStorage.setItem(`current_conv_item_${process.env.APP_MODE}`, id);
    localStorage.setItem(`current_order_item_${process.env.APP_MODE}`, orderId);
  },

  // *[NAV_TO_ORDER_CONV]({ payload }) {
  //   const { orderId } = payload
  //   const conv = yield select(getConvByOrderIdSelector(orderId))
  //   if (!conv) {
  //     return message.info('工单不存在')
  //   }

  //   yield put(navToConversation(conv.get('_id')))
  // },
  *[QUERY_CONV_STATS]({ payload }) {
    const { type } = payload;
    const data = yield call(services.getConvStats, type);
    yield put(convStatsFetched(type, data.total))
  },
  *[FETCH_CONVERSATIONS]({ payload }) {
    const { orderId, convId, queryType, user_id } = payload;
    const params = { type: queryType, user_id: user_id };
    const conversations = yield call(services.fetchConversations, params);
    // const orders = conversations.data.map(conv => conv.order)
    yield put(convsFetched(conversations.data, queryType));
    let nextActiveConv;
    if (orderId) {
      nextActiveConv = conversations.data.find(
        (conv) => conv.order._id === orderId
      );
      if (!nextActiveConv) return message.info('工单不存在');
    } else if (convId) {
      nextActiveConv = conversations.data.find((conv) => conv._id === convId);
    }
    if (nextActiveConv) yield put(navToConversation(nextActiveConv._id, nextActiveConv.order_id));
  },


  *[RECEIVE_MESSAGE]({ payload }) {
    const { createBy, from_type: from, text, message_type } = payload;
    const currentUser = yield select(getCurrentUser);
    const conv = yield select(getConvByOrderIdSelector(payload.order_id));
    // system msg || sent by others
    const isSystemMsg = !createBy;
    const isOthersSent = currentUser.get('_id') !== createBy?._id;
    const sentByOtherPlatform =
      !isOthersSent && (isTenantMode ? from === 'manager' : from === 'staff');
    if (isSystemMsg || isOthersSent || sentByOtherPlatform) {
      if (playRingLock) {
        return;
      }
      playRingLock = true; // 应该用throttle
      var audio = new Audio();
      //order_created
      //no_service_time
      //worker_signin_timeout
      //tenant_confirm_completed
      //platform_confirm_completed
      //cs_connected
      //tenant_staff_changed
      //worker_location_checked
      //worker_feedback
      //assigned_to_worker
      //service_time_changed
      //fee_changed
      //tag_changed
      let video = null
      if (message_type == 'system_msg') {
        if (text == 'order_created') {
          video = 'new_order.mp3'
        } else if (text == 'order_appeal') {
          video = 'order_appeal.mp3'
        } else if (text == 'worker_location_checked') {
          video = 'worker_location_checked.mp3'
        } else if (text == 'service_time_changed') {
          video = 'service_time_changed.mp3'
        } else if (text == 'worker_completed' || text == 'worker_feedback') {
          video = 'worker_completed.mp3'
        } else if (text == 'lock_fee_succeed') {
          video = 'notify.mp3'
        } else if (text == 'lock_fee_faild') {
          video = 'changed.mp3'
        } else if (text == 'appeal_changed' || 'cs_connected' == text ||
          'tenant_staff_changed' == text || 'assigned_to_worker' == text) {
          video = 'action.mp3'
        }
        /*else if(text.endsWith('_changed')){
          video = 'changed.mp3'
        } else if(text.endsWith('_checked')){
          video = 'checked.mp3'
        }else if(text.endsWith('_completed')){
          video = 'notify2.mp3'
        }*/
      } else if (message_type == 'text') {
        video = 'new_message.mp3'
      }
      if (video) {
        return false;
        audio.src = process.env.PUBLIC_URL + '/' + video;
        audio.play();
        audio.addEventListener('ended', () => {
          audio.remove();
          playRingLock = false;
        });
      } else {
        playRingLock = false;
      }
      //管理模式才刷新订单
      if (!isTenantMode) {
        const queryType = 1
        const data = yield call(services.getConvStats, queryType);
        yield put(convStatsFetched(queryType, data.total))
        const currentQueryType = yield select(getConvQueryTypeSelector)
        //刷新待接收订单列表
        if (queryType == currentQueryType) {
          yield put(fetchConvs({ queryType: 2 }))
        }
      }
    }
    if (!conv) {
      return;
    }
    yield put(hoistConv(conv.get('_id')));
  },

  *[TOGGLE_PINNED]({ payload }) {
    const { id } = payload;
    const conv = yield select(getConvByIdSelector(id));
    const newConvData = yield call(services.updateConversation, id, {
      is_pinned: !conv.get('is_pinned'),
    });

    yield put(pinnedChange(id, newConvData.is_pinned));
    yield put(convUpdated(newConvData));
  },

  *[MARK_READ]({ payload }) {
    const { id } = payload;
    yield call(services.markRead, id);
    yield put(markReadSuccess(id));
    if (isTenantMode) {
      yield put(fetchStaffConvs({}));
    } else {
      // yield put(fetchGroupManager({}));
    }
  },

  *[RTM_CONV_CREADTED]({ payload }) {
    const { order, ...conv } = payload;

    if (isTenantMode && payload.user_type !== 'staff') {
      return;
    }

    if (!isTenantMode && payload.user_type !== 'manager') {
      return;
    }

    yield put(addOrder(order));
    yield put(addConversation(conv));

    // 如果当前客户端是发件方，则将焦点移到这里
    if (window.uid === order.tenantAssignTo) {
      yield put(navToConversation(conv._id, conv.order_id));
    }
  },

  *[REMOVE_CONVERSATION]({ payload }) {
    const { id } = payload;
    const currentId = yield select(currentConvIdSelector);
    console.log('currentId:', currentId);

    if (id === currentId) {
      const firstConv = yield select(firstConvSelector);
      yield put(navToConversation(firstConv || null, null));
    }

    // 如果是当前工单，则跳到其他conv
  },
};
